import { object, string } from 'yup';

export const schema = object().shape(
  {
    email: string().when('email', (val) => {
      if (val[0]?.length > 0) {
        return string().email().required();
      } else {
        return string().notRequired();
      }
    }),
    password: string().when('password', (val) => {
      if (val[0]?.length > 0) {
        return string().required();
      } else {
        return string().notRequired();
      }
    }),
    asan_imza_phone: string().when('asan_imza_phone', (val) => {
      if (val[0]?.length > 0) {
        return string().required();
      } else {
        return string().notRequired();
      }
    }),
    asan_imza_id: string().when('asan_imza_id', (val) => {
      if (val[0]?.length > 0) {
        return string().required();
      } else {
        return string().notRequired();
      }
    }),
  },
  [
    ['email', 'email'],
    ['password', 'password'],
    ['asan_imza_phone', 'asan_imza_phone'],
    ['asan_imza_id', 'asan_imza_id'],
  ]
);
